import React, { useEffect, useState } from "react";
import { useToaster } from "../../context/ToasterContext";
import ButtonComponent from "../../components/button";
import { formatAmountInLocale, getMinimumAmountForCurrency } from "../../utils/global";
import { ReactComponent as DollarCircleIcon } from "../../assets/icons/dollar-circle.svg";

const PaymentAmountScreen = ({ order_type, loading, shopDetails, currentOrderData, splitAmountToBePaid, getOrderStatusResult, setStep, createPaymentIntentApiCall, mountPaymentElements, set_splitAmountToBePaid, setScreenName, pageName }) => {
  const { toaster } = useToaster();

  const amountSubmitForm = (e) => {
    e.preventDefault();

    if(splitAmountToBePaid === '' || splitAmountToBePaid === null || splitAmountToBePaid === 0){
      toaster.error("Please enter the amount!");
    }
    if(parseFloat(splitAmountToBePaid) === 0){
      toaster.error("Please enter the amount!");
    }
    else if(parseFloat(splitAmountToBePaid) < parseFloat(getMinimumAmountForCurrency(shopDetails.user_currency))){
      toaster.error("Sorry! The entered amount is below the minimum required to proceed with the transaction.");
    }
    else if(parseFloat(splitAmountToBePaid) > parseFloat(getOrderStatusResult.amount_left)){
      toaster.error("Sorry! The amount entered cannot exceed the remaining amount to be paid.");
    }
    else if(((parseFloat(getOrderStatusResult.amount_left) - parseFloat(splitAmountToBePaid)) < parseFloat(getMinimumAmountForCurrency(shopDetails.user_currency))) && (parseFloat(getOrderStatusResult.amount_left) - parseFloat(splitAmountToBePaid) !== 0)){
      toaster.error("Sorry! The entered amount is valid for now, but it's below the minimum required for the next transaction. Please pay full amount "+ shopDetails.currency_with_symbol +""+ formatAmountInLocale(shopDetails.user_currency,getOrderStatusResult.amount_left));
    }
    else{
      if(pageName === 'shopify-payment'){
        setScreenName("payment");
      }
      
      setStep(2);

      if(pageName === 'stripe-payment' || pageName === 'adyen-payment' || pageName === 'airwallex-payment' || pageName === 'tyro-payment' || pageName === 'nets-payment'){
        createPaymentIntentApiCall(currentOrderData);
      }
      else if(pageName === 'square-payment'){
        mountPaymentElements();
      }
    }
  };

  return (
    <>
      <div>
        <div className="text-center mb-3">
          <p className="text-color-amount-label">Amount left to be paid</p>
          {!loading && <h4 className="text-color-amount-heading">{shopDetails.currency_with_symbol}{formatAmountInLocale(shopDetails.user_currency,getOrderStatusResult.amount_left)}</h4>}
        </div>

        <form id="amount-form" className="whiteCard mt-5" onSubmit={amountSubmitForm}>
          {order_type === 'variable_self' &&
            <div className="mt-0 mb-3">
              <p className="note">Tell us how much to put on this card, then hit continue</p>
            </div>
          }
          {order_type !== 'variable_self' &&
            <div className="mt-0 mb-3">
              <p className="note">Enter your share to continue</p>
            </div>
          }
          <hr />
          
          <div className="input-wrapper mb-0">
            <label className="form-label">
              <DollarCircleIcon className="DollarCircleIcon align-middle" />
              {' '}
              <span className="align-middle">Enter amount</span>
            </label>

            <div className="input-group mb-3">
              <span className="input-group-text">{shopDetails.currency_with_symbol}</span>

              <input type="number" id="amount" className="form-control" placeholder="e.g. 500" min="0" step="0.01" inputMode="decimal" value={splitAmountToBePaid || ''} disabled={loading} onChange={(e) => {
                set_splitAmountToBePaid(e.target.value);
              }} />
            </div>

            <ButtonComponent
              type="submit"
              id="submit_amount_btn"
              className="btn btn-primary btn-pool-shadow btn-pool-full"
              label="Continue"
              size="md"
              variant="primary"
            ></ButtonComponent>
          </div>
        </form>
      </div>
    </>
  );
};

export default PaymentAmountScreen;
